var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSaveProject = function SvgSaveProject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5H13.3333C13.5136 2.5 13.6891 2.55848 13.8333 2.66667L17.1667 5.16667C17.3765 5.32405 17.5 5.57104 17.5 5.83333V16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H3.33333C2.8731 17.5 2.5 17.1269 2.5 16.6667V3.33333ZM4.16667 4.16667V15.8333H15.8333V6.25L14.1667 5V9.16667H5.83333V4.16667H4.16667ZM7.5 4.16667V7.5H12.5V4.16667H7.5ZM14.1667 12.5H5.83333V10.8333H14.1667V12.5Z",
    fill: "white"
  }))));
};
export { SvgSaveProject as ReactComponent };
export default __webpack_public_path__ + "assets/0773eb7e.svg";